module.exports = __webpack_public_path__ + "img/live-streaming-active.4d2ddabc.svg";